import { UploadStatus } from '@/generated/graphql';
import { computed, ref, Ref, watch } from 'vue';

export function usePendingLogo(status: Ref<UploadStatus | null | undefined>) {
    // Only for failures this page saw happen, a page loaded afterwards shows the current logo
    const hasProcessingFailedWhileOpen = ref(false);

    const logoState = computed<'Default' | 'Processing' | 'Processing-Failed'>(() => {
        if (status.value === UploadStatus.Pending) {
            return 'Processing';
        }
        return hasProcessingFailedWhileOpen.value ? 'Processing-Failed' : 'Default';
    });

    // Set by the form that saved the upload, so it is unknown after a reload
    const pendingLogoUrl = ref<string>();

    watch(status, (newStatus, oldStatus) => {
        hasProcessingFailedWhileOpen.value = oldStatus === UploadStatus.Pending && newStatus === UploadStatus.Failed;
    });

    watch(logoState, (state) => {
        if (state !== 'Processing') {
            pendingLogoUrl.value = undefined;
        }
    });

    return {
        logoState,
        pendingLogoUrl,
    };
}

export type PendingLogo = ReturnType<typeof usePendingLogo>;
